import clsx from 'clsx';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

interface ActionButtonProps {
  className?: string;
  type?: string;
  content: string;
  action?: (e) => void;
  disable?: boolean;
  href?: string;
  icon?: React.ReactNode;
  'data-testid'?: string;
  iconPosition?: 'left' | 'right';
}

export function ActionButton({
  className,
  type,
  content,
  action,
  disable,
  href,
  icon,
  iconPosition = 'right',
  'data-testid': dataTestId,
}: ActionButtonProps) {
  if (href) {
    return (
      <Link
        to={href}
        data-testid={dataTestId}
        className={clsx(
          className,
          type === 'dark' ? styles.darkRoot : styles.lightRoot,
          disable ? styles.disable : styles.noDisable,
          !icon ? styles.noIcon : iconPosition === 'left' ? styles.iconLeft : styles.iconRight
        )}
        onClick={disable ? () => {} : action}
      >
        {icon && iconPosition === 'left' && icon}
        <p className={type === 'dark' ? styles.lightDes : styles.darkDes}>{content}</p>
        {icon && iconPosition === 'right' && icon}
      </Link>
    );
  }
  return (
    <div
      data-testid={dataTestId}
      className={clsx(
        className,
        type === 'dark' ? styles.darkRoot : styles.lightRoot,
        disable ? styles.disable : styles.noDisable,
        !icon ? styles.noIcon : iconPosition === 'left' ? styles.iconLeft : styles.iconRight
      )}
      onClick={disable ? () => {} : action}
    >
      {icon && iconPosition === 'left' && icon}
      <p className={type === 'dark' ? styles.lightDes : styles.darkDes}>{content}</p>
      {icon && iconPosition === 'right' && icon}
    </div>
  );
}
